// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__wTL6+","fadeOut":"Popup_fadeOut__sE+aC","title":"Popup_title__rK741","open":"Popup_open__ZqOOm","closed":"Popup_closed__bTMVA"};